import { Provider } from "./provider/Provider";

const SayfalarService = {
  sayfaGetir: ({ sayfaCode }) => {
    return Provider({
      sayfaCode,
      methodName: "Module/Sayfalar/SayfaGetir",
    });
  },
  sayfaListesi: () => {
    return Provider({
      methodName: "Module/Sayfalar/SayfaListesi",
    });
  },
  sayfaEkle: ({
    baslik,
    icerik,
    link,
    thumbnail,
    parent,
    seoIcerik,
    publish,
  }) => {
    return Provider({
      baslik,
      icerik,
      link,
      thumbnail,
      parent,
      seoIcerik,
      publish,
      methodName: "Module/Sayfalar/SayfaEkle",
    });
  },
  sayfaGuncelle: ({
    sayfaCode,
    baslik,
    icerik,
    link,
    thumbnail,
    parent,
    seoIcerik,
    publish,
  }) => {
    return Provider({
      sayfaCode,
      baslik,
      icerik,
      link,
      thumbnail,
      parent,
      seoIcerik,
      publish,
      methodName: "Module/Sayfalar/SayfaGuncelle",
    });
  },
  sayfaKaldir: ({ sayfaCode }) => {
    return Provider({
      sayfaCode,
      methodName: "Module/Sayfalar/SayfaKaldir",
    });
  },
  yayinaAl: ({ sayfaCode }) => {
    return Provider({
      sayfaCode,
      methodName: "Module/Sayfalar/YayinaAl",
    });
  },
  taslakOlarakKaydet: ({ sayfaCode }) => {
    return Provider({
      sayfaCode,
      methodName: "Module/Sayfalar/TaslakOlarakKaydet",
    });
  },
};

export default SayfalarService;
